/**
 * 구독 카드 컴포넌트
 * FSD: features/subscription/subscription-manage/ui
 */

import React from 'react';
import type { Subscription } from '@/entities/subscription/model';
import { formatAmount, formatDate } from '@/shared/lib/payment/format-amount';
import {
  SUBSCRIPTION_STATUS_LABELS,
  getStatusClass,
} from '@/shared/lib/payment/payment-status';

interface SubscriptionCardProps {
  subscription: Subscription;
}

export const SubscriptionCard: React.FC<SubscriptionCardProps> = ({ subscription }) => {
  return (
    <div className={`subscription-card ${getStatusClass(subscription.status)}`}>
      <div className="card-header">
        <h3>{subscription.product?.name || '구독 상품'}</h3>
        <span className={`status-badge ${getStatusClass(subscription.status)}`}>
          {SUBSCRIPTION_STATUS_LABELS[subscription.status]}
        </span>
      </div>

      <div className="card-body">
        <div className="info-row">
          <span className="label">월 결제액</span>
          <span className="value">
            {formatAmount(subscription.product?.price || 0)}
          </span>
        </div>

        <div className="info-row">
          <span className="label">구독 시작일</span>
          <span className="value">{formatDate(subscription.start_date)}</span>
        </div>

        <div className="info-row">
          <span className="label">마지막 결제일</span>
          <span className="value">
            {subscription.last_billing_date
              ? formatDate(subscription.last_billing_date)
              : '결제 대기 중'}
          </span>
        </div>

        <div className="info-row">
          <span className="label">다음 결제 예정일</span>
          <span className="value">
            {subscription.next_billing_date
              ? formatDate(subscription.next_billing_date)
              : '미정'}
          </span>
        </div>

        {subscription.last_payment_failed_date && (
          <div className="failure-info">
            <h4>⚠️ 결제 실패 정보</h4>
            <p>마지막 실패: {formatDate(subscription.last_payment_failed_date)}</p>
            <p>오류: {subscription.last_payment_error}</p>
            <p>재시도 횟수: {subscription.retry_count || 0}/3</p>
          </div>
        )}
      </div>
    </div>
  );
};
